<template>
<div class="wrapper">
      <div class="back" @click="$router.go(-1)"></div>

  <h1>Change your password</h1>
  <div class="input">
        <p>Current Password</p>
        <div class="input-container">
      <input type="email" placeholder="Current Password" v-model="password" />
      </div>
      </div>
            <div class="input">
        <p>New password</p>
        <div class="input-container">
      <input type="email" placeholder="New Password" v-model="newPassword" />
      </div>
      </div>
          <button class="buttonDefault button" @click="changePassword">Confirm</button>
</div>
</template>

<script>
import { Auth } from 'aws-amplify';

export default {
  data() {
    return {
      newPassword: '',
      password: '',
    };
  },
  methods: {
    changePassword() {
      Auth.currentAuthenticatedUser()
        .then((user) => Auth.changePassword(user, this.password, this.newPassword))
        .then((data) => this.$store.dispatch('addNotification', {
          type: 'green',
          title: data,
          comment: 'Password changed',
        }))
        .catch((err) => this.$store.dispatch('addNotification', {
          type: 'red',
          title: 'Error',
          comment: err.name,
        }));
    },
  },

};
</script>

<style scoped>

button {
  margin-top: 50px;
  width: 126px;
  height: 63px;
  background-color: var(--surface-dark);
  border-radius: var(--border-radius);
  font-weight: 500;
  font-size: 20px;
}

.input:nth-of-type(2) {
  margin-top: 50px;
}

.wrapper {
   margin-top: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
h1 {
    font-weight: 500;
    font-size: 24px;
}
</style>
